import EmptyLayout from "@/layout/OrgProfile";

const projectRouter = {
  path: "/org",
  name: "Organization",
  redirect: "/org/profile",
  component: EmptyLayout,
  children: [
    {
      path: "profile",
      name: "OrgProfile",
      component: () => import("@/views/Organization/Profile.vue"),
      meta: {
        user_org: true,
      },
    },
    {
      path: `students-list`,
      name: "OrgGetStudentsList",
      component: () => import("@/views/Organization/getStudentsList.vue"),
      meta: {
        user_org: true,
      },
    },
    {
      path: `course-add`,
      name: "CourseAddingPage",
      component: () => import("@/views/Organization/AddingCourse.vue"),
      meta: {
        user_org: true,
      },
    },
    {
      path: `education-center-edit`,
      name: "EducationCenterEdit",
      component: () => import("@/views/Organization/EditEducationCenter.vue"),
      meta: {
        user_org: true,
      },
    },
    {
      path: `requests-list`,
      name: "EducationRequestsList",
      component: () => import("@/views/Organization/RequestsList.vue"),
      meta: {
        user_org: true,
      },
    },
    {
      path: `notifications`,
      name: "OrgNotifications",
      component: () => import("@/views/Organization/Notifications.vue"),
      meta: {
        user_org: true,
      },
    },
  ],
};

export default projectRouter;
